import { createSelector, createStoreChunk } from '@core/store'
import type { TCookieConsent } from '@core/analytics'

export type { TCookieConsent }

type TCookieConsentState = {
    cookieConsent: TCookieConsent
    /** GTM id from the backend app-blob (`app.tagManager.gtmId`); empty = GTM disabled. In-memory. */
    gtmId: string
    /** Whether the visitor's country gates GTM behind consent (EU27 + GB). In-memory, set at boot. */
    isEuVisitor: boolean
}

// Not persisted on purpose: a chunk here would shadow `cookies_policy`, which both tiers share.
export const cookieConsentStore = createStoreChunk<TCookieConsentState>('cookieConsent')({
    initialState: {
        cookieConsent: '',
        gtmId: '',
        isEuVisitor: false,
    },
})

export const getCanCollectDeviceFingerprint = createSelector(
    [cookieConsentStore.props.getCookieConsent, cookieConsentStore.props.getIsEuVisitor],
    (consent, isEuVisitor) => !isEuVisitor || consent === 'allowed',
)
